/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListAssistantProposalsQueryResponse, ListAssistantProposalsPathParams, ListAssistantProposalsQueryParams, ListAssistantProposals400, ListAssistantProposals401, ListAssistantProposals403, ListAssistantProposals404, ListAssistantProposals409, ListAssistantProposals500 } from "../../types/assistantProposalsController/ListAssistantProposals.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListAssistantProposalsUrl(organizationId: ListAssistantProposalsPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/assistant-proposals/` as const }
  return res
}

/**
 * @summary List assistant proposals (farm-scoped, paginated)
 * {@link /api/organizations/:organizationId/assistant-proposals/}
 */
export async function listAssistantProposals(organizationId: ListAssistantProposalsPathParams["organizationId"], params?: ListAssistantProposalsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListAssistantProposalsQueryResponse, ResponseErrorConfig<ListAssistantProposals400 | ListAssistantProposals401 | ListAssistantProposals403 | ListAssistantProposals404 | ListAssistantProposals409 | ListAssistantProposals500>, unknown>({ method : "GET", url : getListAssistantProposalsUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}